import { Stack } from "expo-router";
import { useHeaderBackButton } from "@src/hooks/useHeaderBackButton";
import { isWeb } from "@src/utils/web-helpers";
import { WebLayout } from "@src/components/web/WebLayout.web";
import { CameraTestSignals } from "@src/features/test-signals";
import { useCameraRouteParams } from "@src/hooks/useCameraRouteParams";
import { View, Text } from "@src/components";

/**
 * Support-only per-camera test signal triggers. One route for both platforms —
 * the body is a notice and two rows, which needs no per-platform arrangement.
 */
export default function TestSignalsScreen() {
  const { headerLeft } = useHeaderBackButton();
  const { siteId, cameraKey, hasMissingParams } = useCameraRouteParams();

  const body =
    hasMissingParams ?
      <View flex={1} justifyContent="center" alignItems="center">
        <Text textStyle="md/regular" color="textMuted">
          This link is missing the site or camera.
        </Text>
      </View>
    : <CameraTestSignals siteId={siteId} cameraKey={cameraKey} />;

  return (
    <>
      <Stack.Screen options={isWeb ? { headerShown: false } : { title: "Test signals", headerLeft }} />
      {isWeb ?
        <WebLayout>{body}</WebLayout>
      : body}
    </>
  );
}
